import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

/** True once .env.local has been filled in. */
export const isConfigured = Boolean(url && anonKey)

/**
 * Null until configured, so the app can render a useful "not connected yet"
 * screen instead of crashing on a blank env.
 */
export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : null
